import { forwardRef, useImperativeHandle, useRef } from "react";
import { EditorContent, useEditor } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import Underline from "@tiptap/extension-underline";
import Placeholder from "@tiptap/extension-placeholder";

import { CustomImage } from "./AddImage";
import { ToolBar } from "./ToolBar";

import "./TipTap.scss";

const Tiptap = forwardRef(({ content, ...props }, ref) => {
  const editor = useEditor({
    extensions: [
      StarterKit,
      Underline,
      Placeholder.configure({ placeholder: props.placeholder ?? "Hãy viết gì đó..." }),
      CustomImage,
    ],
    content: content ?? "",
  });

  const editorRef = useRef(null);

  useImperativeHandle(ref, () => ({
    getHtml() {
      return editorRef.current?.getHTML();
    },
    setContent(c) {
      editorRef.current?.commands.setContent(c);
    },
  }));

  if (!editor) return null;
  editorRef.current = editor;

  return (
    <div className="tiptap-editor">
      <ToolBar editor={editor} />
      <EditorContent editor={editor} className="p-3" />
    </div>
  );
});

Tiptap.displayName = "TipTap";

export default Tiptap;
